import { ARBITIUM_EXTENSION, callHandler } from '../core';
import type { HandlerCallResponse } from '../core';

const EXTENSION = ARBITIUM_EXTENSION;
const COMPLETE_RESTART_HANDLER = 'complete_restart';

export async function ecsRestart(ecsCluster?: string): Promise<HandlerCallResponse> {
  const payload: Record<string, unknown> = { action: 'ecs_restart' };
  if (ecsCluster) {
    payload.ecs_cluster = ecsCluster;
  }
  return callHandler(EXTENSION, COMPLETE_RESTART_HANDLER, payload);
}

export async function nukeSystem(
  safeWord: string,
  ecsCluster?: string
): Promise<HandlerCallResponse> {
  const payload: Record<string, unknown> = {
    action: 'nuke',
    safe_word: safeWord,
  };
  if (ecsCluster) {
    payload.ecs_cluster = ecsCluster;
  }
  return callHandler(EXTENSION, COMPLETE_RESTART_HANDLER, payload);
}

